import React from 'react'
import styled from 'styled-components'
import { Banner } from '../../components/comp'
import questions from '../../utils/faqData.json'

const Faqs = () => {
  return (
    <FaqWrapper>
      <Banner>
      <Banner.Header>Frequently Asked Questions</Banner.Header>
      {questions.map((question) => (
        <Banner.Entity key={question.id}>
          <Banner.Question>{question.question}</Banner.Question>
          <Banner.Text>{question.answer}</Banner.Text>
        </Banner.Entity>
      ))}
      </Banner>
    </FaqWrapper>
  )
}

const FaqWrapper = styled.section`
  padding: 100px 0;
`

export default Faqs